/**
 * @deprecated use same function from '@felce/lowcode-utils' instead
 */
export function isI18nData(obj: any): boolean {
  return obj && obj.type === 'i18n';
}
